import {
  React,
  Select,
  Switch,
  Button,
  toast,
  useState,
  Dialog,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  DatePicker,
  DatePanel,
  GetCookie,
  useEffect,
} from "../../../Libraries/Post/GetAllPostRelatedToScreen/ScreenWisePostScheduling/index";
import { useUpdateSidebarSchedulingMutation } from "../../../Redux/service/AllEmpData";

const options = [
  { label: "Monday", value: "Monday" },
  { label: "Tuesday", value: "Tuesday" },
  { label: "Wednesday", value: "Wednesday" },
  { label: "Thursday", value: "Thursday" },
  { label: "Friday", value: "Friday" },
  { label: "Saturday", value: "Saturday" },
  { label: "Sunday", value: "Sunday" },
];

const SidebarScheduling = (props) => {
  const [updateSidebar] = useUpdateSidebarSchedulingMutation();
      const [data, setData] = useState({
        ser_sidebar_id: props?.schinfo?.ser_sidebar_id || null,

        is_scheduled:
          props?.schinfo?.is_scheduled === true ||
          props?.schinfo?.is_scheduled === "true" ||
          props?.schinfo?.is_scheduled === "t" ||
          props?.schinfo?.is_scheduled === 1,

        daywiseOrDatewise:
          props?.schinfo?.date_wise_or_day_wise &&
          props?.schinfo?.date_wise_or_day_wise !== "N/A"
            ? props?.schinfo?.date_wise_or_day_wise
            : "",

        selectedDates:
          props?.schinfo?.date_wise_scheduled_date &&
          props?.schinfo?.date_wise_scheduled_date !== "N/A"
            ? [props?.schinfo?.date_wise_scheduled_date]
            : [],

        values:
          props?.schinfo?.date_wise_scheduled_date &&
          props?.schinfo?.date_wise_scheduled_date !== "N/A"
            ? [props?.schinfo?.date_wise_scheduled_date]
            : [],


        selectedDays:
          props?.schinfo?.days && props?.schinfo?.days !== "N/A"
            ? props?.schinfo?.days
            : [],
    });

  const handleSwitchChange = (e) => {
    setData({
      ...data,
      is_scheduled: e.target.checked,
    });
  };

  const handleScheduleTypeChange = (e) => {
    setData({
      ...data,
      daywiseOrDatewise: e.target.value,
      selectedDays: [],
      selectedDates: [],
    });
  };

  const handleSelectedDaysChange = (e) => {
    setData({
      ...data,
      selectedDays: e,
    });
  };

  const handleSelectedDatesChange = (e) => {
    const dates = e.map((date) => date.format("YYYY-MM-DD"));
    setData({
      ...data,
      values: dates,
      selectedDates: dates,
    });
  };
  
  const handleSubmitSidebarScheduling = async () => {
    console.log(data.is_scheduled);
    if (data.is_scheduled && data.daywiseOrDatewise === "") {
      toast.error("Please select the scheduling scheme");
      return;
    }
    const refreshSidebardata = async () => {
      await props.refreshSidebar();
    };
    const payload = new FormData();
    payload.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
    payload.append("security_token", await GetCookie("es_token"));
    payload.append("ser_screen_id", props.screen);
    payload.append("ser_sidebar_id", props.schinfo.ser_sidebar_id);

    if (data.is_scheduled && data.daywiseOrDatewise === "Date wise") {
      payload.append("is_scheduled", data.is_scheduled);
      payload.append("date_wise_or_day_wise", data.daywiseOrDatewise);
      payload.append("date_wise_scheduled_dates", data.selectedDates);
      payload.append("days", "N/A");
    } else if (data.is_scheduled && data.daywiseOrDatewise === "Day wise") {
      const formattedDays = String(data.selectedDays?.map((day) => day.value));
      payload.append("is_scheduled", data.is_scheduled);
      payload.append("date_wise_or_day_wise", data.daywiseOrDatewise);
      payload.append("days", formattedDays);
      payload.append("date_wise_scheduled_dates", "N/A");
    } else if (!data.is_scheduled) {
      payload.append("is_scheduled", data.is_scheduled);
      payload.append("date_wise_or_day_wise", "N/A");
      payload.append("days", "N/A");
      payload.append("date_wise_scheduled_dates", "N/A");
    }

    
    if (
      data.is_scheduled &&
      data.daywiseOrDatewise === "Day wise" &&
      (!data.selectedDays || data.selectedDays.length === 0)
    ) {
      toast.error("Please select at least one day");
      return;
    }
    if (
      data.is_scheduled &&
      data.daywiseOrDatewise === "Date wise" &&
      (!data.selectedDates || data.selectedDates.length === 0)
    ) {
      toast.error("Please select at least one date");
      return;
    }

    try {
      const res = await updateSidebar(payload).unwrap();
      if (res.status === "true" && res.connection === "true") {
        toast.success(res.message);
        props.close();
        refreshSidebardata();
        // props.refreshSidebar?.(); 
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong");
    }
  };

  const footer = (
    <React.Fragment>
      <Button
        variant="contained"
        className="capitalized fs-14 fw-bold"
        onClick={handleSubmitSidebarScheduling}
      >
        {data.is_scheduled ? "Update" : "Add"}
      </Button>
    </React.Fragment>
  );
  useEffect(() => {
  if (props?.schinfo) {
    setData({
      ser_sidebar_id: props?.schinfo?.ser_sidebar_id || null,

      is_scheduled:
        props?.schinfo?.is_scheduled === true ||
        props?.schinfo?.is_scheduled === "true" ||
        props?.schinfo?.is_scheduled === "t" ||
        props?.schinfo?.is_scheduled === 1,

      daywiseOrDatewise:
        props?.schinfo?.date_wise_or_day_wise &&
        props?.schinfo?.date_wise_or_day_wise !== "N/A"
          ? props?.schinfo?.date_wise_or_day_wise
          : "",

      selectedDates:
        props?.schinfo?.date_wise_scheduled_date &&
        props?.schinfo?.date_wise_scheduled_date !== "N/A"
          ? [props?.schinfo?.date_wise_scheduled_date]
          : [],

      values:
        props?.schinfo?.date_wise_scheduled_date &&
        props?.schinfo?.date_wise_scheduled_date !== "N/A"
          ? [props?.schinfo?.date_wise_scheduled_date]
          : [],

      selectedDays:
        props?.schinfo?.days && props?.schinfo?.days !== "N/A"
          ? props?.schinfo?.days
          : [],
    });
  }
}, [props.schinfo]);

  return (
    <Dialog
      visible={props.show}
      style={{ width: "500px" }}
      breakpoints={{ "960px": "75vw", "640px": "100vw" }}
      header="Sidebar Scheduling"
      modal
      footer={footer}
      onHide={props.close}
    >
      <div className="row">
        <div className="col">
          <div className="form-group">
            <label>Sidebar Schedule</label>
            <Switch
              checked={data.is_scheduled}
              inputProps={{ "aria-label": "controlled" }}
              onChange={handleSwitchChange}
            />
          </div>
        </div>
      </div>

      {data.is_scheduled && (
        <>
          <div className="row">
            <div className="col">
              <FormControl>
                <RadioGroup
                  row
                  value={data.daywiseOrDatewise}
                  onChange={handleScheduleTypeChange}
                >
                  <FormControlLabel
                    value="Day wise"
                    control={<Radio />}
                    label="Day wise"
                  />
                  <FormControlLabel
                    value="Date wise"
                    control={<Radio />}
                    label="Date wise"
                  />
                </RadioGroup>
              </FormControl>
            </div>
          </div>

          {data.daywiseOrDatewise === "Day wise" && (
            <div className="row">
              <div className="col">
                <div className="form-group">
                  <label>Schedule Days</label>
                  <Select
                    options={options}
                    isMulti
                    isClearable
                    value={data.selectedDays}
                    onChange={handleSelectedDaysChange}
                    placeholder="Select Days"
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={{
                      menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
                      menu: (provided) => ({ ...provided, zIndex: 9999 }),
                    }}
                  />
                </div>
              </div>
            </div>
          )}

          {data.daywiseOrDatewise === "Date wise" && (
            <div className="row">
              <div className="col">
                <DatePicker
                  // multiple
                  sort
                  calendarPosition="bottom-center"
                  value={data.values}
                  onChange={handleSelectedDatesChange}
                  minDate={new Date(new Date().setDate(new Date().getDate() + 1))}
                  plugins={[<DatePanel key={data.values} />]}
                />
              </div>
            </div>
          )}
        </>
      )}
    </Dialog>
  );
};

export default SidebarScheduling;
